import { Trans } from '@lingui/macro'
import { Alert, AlertTitle } from '@mui/material'
import React from 'react'

export const IncompleteOrganizationDetails: React.FC<{}> = () => {
  return (
    <Alert variant='filled' severity='info'>
      <AlertTitle>
        <Trans>INCOMPLETE_ORGANIZATION_DETAILS_TITLE_ALERT</Trans>
      </AlertTitle>
      <Trans>INCOMPLETE_ORGANIZATION_DETAILS_DESCRIPTION_ALERT</Trans>
    </Alert>
  )
}
